module.exports = __webpack_public_path__ + "static/media/original(3).3c90376b.webp";